"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gridListColumnSelector = void 0;
/**
 * Get the list column definition
 * @category List View
 * @ignore - Do not document
 */
const gridListColumnSelector = state => state.listViewColumn;
exports.gridListColumnSelector = gridListColumnSelector;